import { Link } from "react-router-dom";
import { BookOpen, Calendar } from "lucide-react";
import Loader from "../../../components/Loader/Loader";
import { useStudentCourses } from "./hooks/useStudentCourses";
import {
  formatCourseDate,
  getCourseClassLabel,
  getCourseDate,
  getCourseDescription,
  getCourseId,
  getCourseSubject,
  getCourseTitle,
} from "./courseFieldUtils";
import "./StudentCourses.css";

// Renders only its own content — StudentPortalLayout already provides the
// sidebar/header shell around every route.
const StudentCourses = () => {
  const { courses, isLoading } = useStudentCourses();

  if (isLoading) return <Loader />;

  if (!courses.length) {
    return (
      <div className="sp-card">
        <div className="sp-empty-state">
          <BookOpen size={32} />
          <h3 className="mb-0">No courses yet</h3>
          <p className="text-muted mb-0">Your class's lesson plans will show up here once they're added.</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h2 className="sp-section-title">Courses</h2>
      <div className="sp-card-grid">
        {courses.map((course) => {
          const id = getCourseId(course);
          const subject = getCourseSubject(course);
          const classLabel = getCourseClassLabel(course);
          const date = getCourseDate(course);
          const description = getCourseDescription(course);

          return (
            <Link
              key={id ?? getCourseTitle(course)}
              to={`/student-portal/courses/${id}`}
              className="sp-card sp-card--hoverable sp-course-card"
            >
              <div className="sp-course-card__top">
                <span className="sp-icon-tile" data-tone="primary">
                  <BookOpen size={18} />
                </span>
                <div className="sp-course-card__heading">
                  <h3 className="mb-0">{getCourseTitle(course)}</h3>
                  {(subject || classLabel) && (
                    <p className="text-muted small mb-0">{[subject, classLabel].filter(Boolean).join(" · ")}</p>
                  )}
                </div>
              </div>
              {date && (
                <p className="sp-course-card__meta text-muted small mb-2">
                  <Calendar size={14} /> {formatCourseDate(date)}
                </p>
              )}
              {description && <p className="mb-0 sp-course-card__desc">{description}</p>}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default StudentCourses;
